import { z } from 'zod';
import { emailSchema, idSchema } from './common.js';
/**
 * "Something not right?" (V2-U7, frozen amendment 2026-08-07) —
 * deliberately low-threshold product feedback. One free-text field, no
 * severity, no category; context auto-attached by the client.
 */
export const supportReportAppSchema = z.enum(['work-driver', 'dispatcher']);
export const createSupportReportBodySchema = z
    .object({
    message: z.string().trim().min(1).max(4000),
    app: supportReportAppSchema,
    fleetId: idSchema.nullable().optional(),
    appVersion: z.string().trim().max(40).nullable().optional(),
    build: z.string().trim().max(40).nullable().optional(),
    screen: z.string().trim().max(160).nullable().optional(),
    activeLoadRef: z.string().trim().max(40).nullable().optional(),
    deviceOs: z.string().trim().max(80).nullable().optional(),
    /** Key returned by screenshot-init; the server HEAD-verifies it. */
    screenshotKey: z.string().trim().max(255).nullable().optional(),
})
    .strict();
/**
 * Pre-auth "Something not right?" (Support v1) — the sign-in screens' quiet
 * link. Text only (no screenshot field AT ALL — .strict() refuses one), a
 * reply email instead of a session, and only the context that exists before
 * auth. Sits behind a per-IP brake server-side.
 */
export const preAuthSupportBodySchema = z
    .object({
    message: z.string().trim().min(1).max(4000),
    reporterEmail: emailSchema,
    app: supportReportAppSchema,
    appVersion: z.string().trim().max(40).nullable().optional(),
    build: z.string().trim().max(40).nullable().optional(),
    screen: z.string().trim().max(160).nullable().optional(),
    deviceOs: z.string().trim().max(80).nullable().optional(),
})
    .strict();
/** Support (Lee) reply into a ticket thread. */
export const supportReplyBodySchema = z
    .object({ body: z.string().trim().min(1).max(4000) })
    .strict();
export const supportTicketStatusSchema = z.enum(['open', 'replied', 'closed']);
export const supportQueueQuerySchema = z.object({
    status: supportTicketStatusSchema.optional(),
    limit: z.coerce.number().int().min(1).max(200).default(100),
    offset: z.coerce.number().int().min(0).default(0),
});
export const supportTicketParamSchema = z.object({ ticketId: idSchema });
/** Screenshots are phone/browser captures — images only, 5MB cap. */
export const supportScreenshotMimeSchema = z.enum(['image/jpeg', 'image/png']);
export const SUPPORT_SCREENSHOT_MAX_BYTES = 5 * 1024 * 1024;
export const supportScreenshotInitBodySchema = z
    .object({
    mimeType: supportScreenshotMimeSchema,
    sizeBytes: z.number().int().min(1).max(SUPPORT_SCREENSHOT_MAX_BYTES),
})
    .strict();
//# sourceMappingURL=support.js.map